module.exports = __webpack_public_path__ + "img/sensores_de_presion.275abbcf.jpg";